import { render, staticRenderFns } from "./AppAuthenticationResetPassword.vue?vue&type=template&id=4b4dcb60&"
import script from "./AppAuthenticationResetPassword.vue?vue&type=script&lang=ts&"
export * from "./AppAuthenticationResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports